import React, { Component } from 'react';
import { Flex, List, Tag } from 'antd-mobile';
import { Link } from "react-router-dom";
const Item = List.Item;
export class PacksItems extends Component {
    componentDidMount() {
    }

    render() {
        const packData = this.props.packData;
        const type = this.props.type;
        return (<div className="package"><div className="items">
            <Item
                arrow="horizontal"
                multipleLine
            >
                <Link to={`/package/details/${this.props.packData.packid}/0`}>
                    <Flex align="start">
                        <img src={packData.picture.length === 0 ? require('../../res/images/zw.jpg') : packData.picture[0].picpath} alt="" />
                        <div className="items__right">
                            <span>{packData.title}</span>
                            <span>{type === 'h' ? '' : packData.mcName}{type === 'h' && packData.gender === 0 ? <Tag small className="tagbg" >通用</Tag> : <br></br>}</span>
                            <span className="gray" >套餐价格：<b className="red">{packData.realprice} </b>  {
                                parseFloat(packData.realprice) === parseFloat(packData.marketprice) ? '' :
                                    <b className="yh">{packData.marketprice}</b>
                            }

                            </span>
                        </div>
                    </Flex>
                </Link>
            </Item>
        </div></div>);
    }

}